import * as React from 'react';
import { SVGProps } from 'react';

const IconCalendarSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 1a.5.5 0 0 0-.5.5V2H2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H9v-.5a.5.5 0 0 0-1 0V2H4v-.5a.5.5 0 0 0-.5-.5zM10 4H2v6h8V4z"
    />
  </svg>
);
export default IconCalendarSizeXs;
